define('views/user/forgotpassword/forgotpassword',[
    'backbone',
    'text!views/user/forgotpassword/forgotpassword.html',
    'views/_base/baseview',
    'models/shared/lookups/systext',
    'models/validator/email'
], function(Backbone, Template, BaseView, SystemText, EmailValidator){
    'use strict';

    return BaseView.extend({
        id       : 'forgotPassword',
        tagName  : 'section',
        template : _.template(Template),
        isRender : true,
        needsAuth: false,
        events   : {
            'input .md-input'               : 'handleMaterialInputLabel',
            'submit .js-forgotPasswordForm' : 'submitemailaddress'
        },

        initialize: function(options){
            options = options || {};
            BaseView.prototype.initialize(this);
        },

        render: function(){

            this.$el.html(this.template());
            this.elEmailInput = this.$('#forgot-password-email');
            this.elEmailFeedback = getMDInputFeedbackEl(this.elEmailInput);

            this.$('#addcb').append('<button type="submit" id="Optional" class="btn btn-default">' + pf.getContent('login.forgot_password.button_text') + '</button>');
            
            return this;
        },

        handleMaterialInputLabel: function(e){
            handleMDInputLabel( $(e.target) );
        },

        validateEmail: function(){
            var email = this.elEmailInput.val(),
                validator = new EmailValidator;
            
            validator.validate(email);
            
            if(validator.isValid()){
                styleMDInputDefault(this.elEmailInput);
                removeMDFeedback(this.elEmailFeedback);
            } else {
                styleMDInputInvalid(this.elEmailInput);
                addMDFeedback(this.elEmailFeedback, pf.getContent('validation.email.invalid'));
            }

            return validator;
        },

        submitemailaddress: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            // honey pot ----------------------------------
            if($('#WebsiteInfo input').val() !== ''){
                alert('Failed to submit request.');
                return false;
            }
            // --------------------------------------------

            var emailValidator = this.validateEmail();
            
            if(emailValidator.isValid()){
                var that = this;

                $.ajax({
                    type   : 'GET',
                    url    : pf.userURL + '/ForgotPassword',
                    async  : false,
                    contentType: 'application/json',
                    data   : { emailAddress: emailValidator.get('value') },
                    success: function(){
                        
                        pfdialog.alert({
                            context: this,
                            Title  : pf.getContent('login.forgot_password.success_title'),
                            Body   : pf.getContent('login.forgot_password.success_body').replace( '{emailProvided}', '<b>' + emailValidator.get('value') + '</b>' )
                        });

                        pf.navigate('');
                    },
                    error: function(resp, status, error){

                        switch(resp.status){
                            case 403: 

                                pfdialog.alert({
                                    context   : this,
                                    Title     : pf.getContent('login.forgot_password.unregistered_title'),
                                    Body      : pf.getContent('login.forgot_password.unregistered_body'),
                                    okCallback: function(){
                                        pf.navigate('register');
                                    }
                                });

                                break;
                            case 401:
                                
                                var bodyText = 'A password has not been provided for this account.<br/><br/> To create one, you must click on the link in your invitation email.';
                           
                                pfdialog.error({
                                    context: this,
                                    Title  : '',
                                    Body   : bodyText
                                });

                                break;
                            
                            default:
                                var bodyText = pf.getContent('login.forgot_password.not_found_body') + '<br /><br /><small>' + pf.getContent('login.forgot_password.not_found_fineprint') + '</small>',
                                    phone = formatPhone(pf.getContent('global.phone.member_services')),
                                    email = pf.getContent('global.email.member_services');
                                
                                bodyText = bodyText.replace('{emailProvided}', '<b>' + emailValidator.get('value') + '</b>');
                                bodyText = bodyText.replace('{memberServicesPhone}', phone);
                                bodyText = bodyText.replace('{memberServicesEmail}', email);

                                pfdialog.error({
                                    context: this,
                                    Title: pf.getContent('login.forgot_password.not_found_title'),
                                    Body: bodyText
                                });

                                break;

                        };

                       
                    }
                });
            }
        },

        close: function(){
            this.model = null;
        }

    });
});
